import './HomeCertificate.css'
import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { messages, options, severProperties } from './utility/Constants';
import axios from 'axios';
import addHookTo from './AddHookTo';
import HeaderMenu from './HeaderMenu';
import { getToken,getRefreshToken,getLocaleLanguage } from './AuthService';
import { Navigate } from 'react-router';
import Button from '@mui/material/Button';
import moment from 'moment';
import { RotatingLines } from "react-loader-spinner";
class HomeCertificate extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      locale: 'en',
      dataField: [],
      loading: true
    };

    this.downloadPdf = this.downloadPdf.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  componentDidMount() {
    this.setState({ locale: getLocaleLanguage() });
    this.setState({ dataField: '', loading: true });
    this.fetchData();
    /*axios.get("https://mocki.io/v1/b4049563-268c-4408-8997-4e04e6a74e04") 
      .then(response => {
        const dataField = response.data;
        this.setState({ dataField });
      });*/
  }

  fetchData = async () => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/applicant/application"].join("");//'http://localhost:8084/applicant/application'; // Replace with your API URL

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ dataField: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

  componentWillUnmount() {
    this.setState({ locale: getLocaleLanguage() });
  }


  handleLanguageChange = (e) => {
    this.setState({ locale: e.target.value });
    localStorage.setItem('laguagePrefered', e.target.value);
  };

  checkString(str1,str2)
  {
    return str1.includes(str2);
  }

  downloadPdf = async (e,applicationId,certificateNo)=> 
  {
    this.setState({ loading: true });
    try {
    const token = getRefreshToken();
    const response = await axios.get(severProperties.serverURL+'/applicant/download?applicationId='+applicationId+'&certificateNo='+certificateNo, {
      headers: { accept: 'application/pdf','Content-Type': 'application/pdf', 
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': severProperties.serverCORS,
      },
      responseType: 'arraybuffer',
    })
 
    const blob = new Blob([response.data], {
      type: 'application/pdf',
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
 
    a.href = url
 
    a.download = certificateNo+'.pdf'
    a.click();
    this.setState({ loading: false });
  }
    catch (error) {
    this.setState({ loading: false });
      if (axios.isAxiosError(error)) {
        // Handle Axios-specific errors
        console.error('Error:', error.message);
        if (error.code === 'ERR_NETWORK_IO_SUSPENDED') {
          // Handle the specific error
          alert('Network request was suspended. Please try again later.');
        }
      } else {
        // Handle other types of errors
        console.error('Unexpected error:', error);
      }
    }

  };

  compareDate(str1)
  {
    var d1 = new Date();
    var d2 = new Date(str1);
    return (d2>d1);
  }
  render() {
    function Loader() {
      return (
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true} />
      )
    }
    
    if ((getToken() === "" || getToken() === null)) {
      return (<Navigate to="/" />);
    }
    if(!this.state.dataField && this.state.loading)
    {
      return(<div style={{display: 'flex',zIndex:'-moz-initial',height:'100vh',width:'100vw',justifyContent: 'center', alignItems: 'center'}}><Loader></Loader></div>)
    }
    else
    {
    return (
      <div className={`app ${this.state.loading ? 'blurred' : ''}`}>
      <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]} defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
        <div style={{ 'width': '100vw' }}>
          <HeaderMenu />
          <center style={{ marginTop: 20 }}> <select onChange={this.handleLanguageChange}
            value={this.state.locale} style={{ height: 35 }}>
            {options.map(option =>
              (<option value={option.value} key={option.index}>{option.label}</option>)
            )
            }
          </select>
          </center>
          <div className="div-grid" style={{ 'margin': '20px' }}>
            {
              this.state.dataField.map(app =>
                <Box sx={{
                  my: 4,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  backgroundColor: '#fff',
                  border: '2px solid lightgrey',
                  borderRadius: 2,
                }}>
                  <Grid container spacing={2}>
                  <Grid size={12}>
                      <div style={{ align: "left!important" }}><h4>{app.referenceId}</h4></div>
                    </Grid>

                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="fname" />} key={app.fname} value={app.applicantFirstName} size="Small" style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="mname" />} key={app.mname} value={!app.applicantMiddleName?" ":app.applicantMiddleName} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="lname" />} key={app.lname} value={app.applicantLastName} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="sex" />} key={app.sex} value={app.applicantGender} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={8}>
                      <TextField variant="standard" label={<FormattedMessage id="dob" />} key={app.DateofBirth} value={moment(new Date(app.applicantBirthdate)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="ApplicationDate" />} key={app.ApplicationDate} value={(app.registrationDate===null || app.registrationDate==="")?" ":moment(new Date(app.registrationDate)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={8}>
                      <TextField variant="standard" label={<FormattedMessage id="AgeonApplication" />} key={app.AgeonApplication} value={app.applicantAgeAtRegistration} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="Nationality" />} key={app.Nationality} value={app.nationalityCountryName} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={4}>
                      <TextField variant="standard" label={<FormattedMessage id="PassportNumber" />} key={app.PassportNumber} value={app.passportNumber} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={8}>
                      <TextField variant="standard" label={<FormattedMessage id="Countryofisuue" />} key={app.Countryofisuue} value={app.nationalityCountryName} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="ExpirationDate" />} key={app.ExpriationDate} value={moment(new Date(app.passportDateExpires)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="PanelPhysician" />} key={app.PanelPhysician} value={!app.panelPhysician?" ":app.panelPhysician} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={6}>
                      <TextField variant="standard" label={<FormattedMessage id="PanelClinic" />} key={app.PanelClinic} value={app.clinicLocationName} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={6}>
                      <TextField variant="standard" label={<FormattedMessage id="PanelID" />} key={app.PanelID} value={!app.clinicLocationNumber?" ":app.clinicLocationNumber} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="PanelclinicAddress" />} key={app.PanelclinicAddress} value={app.clinicLocationAddressLine1 + app.clinicLocationAddressLine2} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="PanelclinicTelephone" />} key={app.PanelclinicTelephone} value={app.clinicLocationTelephone} style={{ width: "100%" }}></TextField>
                    </Grid>
                    {(this.checkString(app.status,"Certificate Issued") && this.compareDate(app.medicalClearanceDateExpires))?
                    <>
                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateNo" />} key={app.CertificateNo} value={app.medicalClearanceNumber} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateIssueDate" />} key={app.CertificateIssueDate} value={moment(new Date(app.medicalClearanceDateIssued)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateValidUntil" />} key={app.CertificateValidUntil} value={moment(new Date(app.medicalClearanceDateExpires)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={12}>
                    <div style={{border: '2px solid lightgrey',alignContent:'justifyContent'}}>
                    Applicants will be required to submit the TB Clearance Certificate when applying for a Certificate of Eligibility (or when applying for a visa at a Japanese diplomatic mission abroad in cases where they apply for a visa without obtaining a Certificate of Eligibility).
                    For more information, please visit <a href="https://jpets.mhlw.go.jp" target="_blank">https://jpets.mhlw.go.jp</a>
                    </div>
                    </Grid>
                
                    <Grid size={12}>
                    <center>
                    <Button variant="contained" className="gfg-button" style={{borderRadius: 40,width:250}} onClick={(e,applicationId,certificateNo)=>this.downloadPdf(e,app.applicationId,app.medicalClearanceNumber)}> {<FormattedMessage id="DownloadCertificate" />} </Button>  
                    </center>                  
                    </Grid>
                    </>
                    :this.checkString(app.status,"Certificate On Hold")?<><Grid size={12}><center>
                    <Button variant="contained" className="gfg-button" style={{borderRadius: 40,width:250,pointerEvents: 'none','backgroundColor':'orange'}}> {<FormattedMessage id="CertificateOnhold" />} </Button></center></Grid></>
                    :this.checkString(app.status,"Certificate Refused")?<><Grid size={12}><center>
                    <Button variant="contained" className="gfg-button" style={{borderRadius: 40,width:250,pointerEvents: 'none','backgroundColor':'red'}}> {<FormattedMessage id="CertificateRefused" />}  </Button></center></Grid></>
                    :(this.checkString(app.status,"Certificate Issued") && !this.compareDate(app.medicalClearanceDateExpires))?
                    <>
                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateNo" />} key={app.CertificateNo} value={app.medicalClearanceNumber} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateIssueDate" />} key={app.CertificateIssueDate} value={moment(new Date(app.medicalClearanceDateIssued)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>

                    <Grid size={12}>
                      <TextField variant="standard" label={<FormattedMessage id="CertificateValidUntil" />} key={app.CertificateValidUntil} value={moment(new Date(app.medicalClearanceDateExpires)).format('DD-MMM-YYYY')} style={{ width: "100%" }}></TextField>
                    </Grid>
                    <Grid size={12}>
                    <div style={{border: '2px solid lightgrey',alignContent:'justifyContent'}}>
                    Applicants will be required to submit the TB Clearance Certificate when applying for a Certificate of Eligibility (or when applying for a visa at a Japanese diplomatic mission abroad in cases where they apply for a visa without obtaining a Certificate of Eligibility).
                    For more information, please visit <a href="https://jpets.mhlw.go.jp" target="_blank">https://jpets.mhlw.go.jp</a>
                    </div>
                    </Grid>
                
                    <Grid size={12}>
                    <center>
                    <Button variant="contained" className="gfg-button" style={{borderRadius: 40,width:250,'pointer-events': 'none','backgroundColor':'grey'}}> {<FormattedMessage id="CertificateExpired" />}  </Button></center>
                    </Grid>
                    </>
                    :<span><font style={{color:'#32de84',fontSize:18}}>{<FormattedMessage id="InProgress" />}</font><br/>{<FormattedMessage id="InProgressSatus" />}</span>}
                    
                  </Grid>
                </Box>
              )}
          </div>

          <div className="footer">
            <p>© 2025 IOM. All rights reserved. version 1.0.0 </p>
          </div>
        </div>     </IntlProvider></div>);
    }
  }
}
//export default HomeCertificate;

export default addHookTo(HomeCertificate);